import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as navigationActions from "../../../../../actions/navigationActions";
import * as windowService from "../../../../../services/windowService";

class RestartRedlikeModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseRestartRedlikeModalAction();
    };

    handleNoButtonClick = () => {
        this.props.dispatchCloseRestartRedlikeModalAction();
    };

    handleYesButtonClick = () => {
        windowService.restartRedlike();
    };

    render() {
        return (
            <div id="modal" className="default-modal ig-restart-modal ig-small-modal">
                <div className="modal-content">
                    <div className="col-xs-12 ">
                        <Translate value="dialog.reallyRestartRedlike" name={this.props.softwareName} />
                    </div>
                    <div className="modal-footer">
                        <div className="col-xs-6 text-right">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleNoButtonClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.no" />
                            </button>
                        </div>
                        <div className="col-xs-6 text-left ">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleYesButtonClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.yes" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        softwareName: store.settings.softwareName
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseRestartRedlikeModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_RESTART_REDLIKE_MODAL));
        }
    };
};

export default RestartRedlikeModal = connect(mapStoreToProps, mapDispatchToProps)(RestartRedlikeModal);
